import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, TAGLINE, PHONE_DISPLAY, PHONE_LINK, ADDRESS_LINES, GSTIN } from "../data/site";

const QUICK = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Why MODORS", to: "/#why-modors" },
  { label: "Technology", to: "/#technology" },
  { label: "Get a Quote", to: "/contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-coal border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-6 font-display text-lg uppercase tracking-[0.2em] text-brand-red">
          {TAGLINE}
        </p>
        <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
          Precision-engineered galvanized steel door and window frames for the Indian
          construction industry.
        </p>
      </div>
      <div>
        <h4 className="font-display text-sm uppercase tracking-[0.25em] text-white/40 mb-6">
          Navigate
        </h4>
        <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
          {QUICK.map((l) => (
            <li key={l.label}>
              <Link
                to={l.to}
                data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-white/70 hover:text-brand-red transition-colors duration-300"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm uppercase tracking-[0.25em] text-white/40 mb-6">
          Contact
        </h4>
        <p className="text-sm font-semibold text-white">{COMPANY}</p>
        <a
          href={PHONE_LINK}
          data-testid="footer-phone-link"
          className="mt-3 flex items-center gap-2 text-sm text-white/70 hover:text-brand-red transition-colors duration-300"
        >
          <Phone className="w-4 h-4 text-brand-red" /> {PHONE_DISPLAY}
        </a>
        <p className="mt-3 flex items-start gap-2 text-sm text-white/70">
          <MapPin className="w-4 h-4 text-brand-red mt-0.5 shrink-0" />
          <span>{ADDRESS_LINES.join(" ")}</span>
        </p>
        <p className="mt-3 text-xs tracking-wider text-white/40">GSTIN: {GSTIN}</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-white/40 tracking-wide">
          © {new Date().getFullYear()} {COMPANY}. All rights reserved.
        </p>
        <p className="text-xs text-white/40 tracking-[0.25em] uppercase">
          MODORS — Steel Door Frames
        </p>
      </div>
    </div>
  </footer>
);
